//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DesignSimulation.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"ColorDisplayStyle",1,0],[0,"ColorScaleRangeType",1,0],[0,"ContourDisplayStyle",1,0],[0,"DisplayType",1,0],[0,"FirstStudy",1,"DesignSimulation.Study",0],[0,"Material",1,"Material",0],[0,"MaterialLimit",1,0],[0,"MaterialLimitBody",1,"DesignSimulation.AnalysisBody",0],[1,"MaxStressCompression",0,"Expression",0],[1,"MaxStressTension",0,"Expression",0],[0,"ResultComponentType",1,0],[0,"SecondStudy",1,"DesignSimulation.Study",0],[0,"SubcaseIndexForFirstStudy",1,0],[0,"SubcaseIndexForSecondStudy",1,0],[1,"YieldStrength",0,"Expression",0]],[],[]];
SPLM.DesignSimulation.ViewContourBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DesignSimulation.ViewContourBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.DesignSimulation.ViewContourBuilder.DisplayOption = Object.freeze({
    "Single" : "Single", "Comparison" : "Comparison"});

SPLM.DesignSimulation.ViewContourBuilder.ResultComponentOption = Object.freeze({
    "DisplacementMagnitude" : "DisplacementMagnitude", "DisplacementWorstInXYZ" : "DisplacementWorstInXYZ", "DisplacementX" : "DisplacementX", "DisplacementY" : "DisplacementY", "DisplacementZ" : "DisplacementZ", "DisplacementAll" : "DisplacementAll", "StressVonMises" : "StressVonMises", "StressWorstPrincipal" : "StressWorstPrincipal", "SafetyFactor" : "SafetyFactor"});

SPLM.DesignSimulation.ViewContourBuilder.ContourDisplayStyleOption = Object.freeze({
    "Smooth" : "Smooth", "Banded" : "Banded"});

SPLM.DesignSimulation.ViewContourBuilder.ColorScaleRangeOption = Object.freeze({
    "PerView" : "PerView", "CommonAcrossViews" : "CommonAcrossViews"});

SPLM.DesignSimulation.ViewContourBuilder.ColorDisplayStyleOption = Object.freeze({
    "Default" : "Default", "Spotlight" : "Spotlight", "MaterialLimit" : "MaterialLimit"});

SPLM.DesignSimulation.ViewContourBuilder.MaterialLimitOption = Object.freeze({
    "AnalysisBody" : "AnalysisBody", "Material" : "Material", "UserDefined" : "UserDefined"});

export default SPLM;